import * as Yup from "yup";

const codigo = Yup.string()
  .required("Código é obrigatório.")
  .test(
    "no-spaces",
    "Código não pode conter espaços.",
    (v) => !v || !/\s/.test(v)
  );

const tipo = Yup.string().required("Tipo de desconto é obrigatório.");

const valor = Yup.string()
  .required("Valor é obrigatório.")
  .test(
    "valor-by-tipo",
    "Valor inválido para o tipo selecionado.",
    function (v) {
      const t = this.parent.tipo as string;
      if (!v) return false;
      const n = Number(String(v).replace(/,/g, "."));
      if (Number.isNaN(n)) return false;
      if (!t) return true;
      if (t === "PORCENTAGEM") return n >= 1 && n <= 100;
      if (t === "VALOR_FIXO") return n > 0;
      return n > 0;
    }
  );

const dataInicio = Yup.string().required("Data de início é obrigatória.");

const dataFim = Yup.string()
  .required("Data de fim é obrigatória.")
  .test(
    "fim-after-inicio",
    "Data fim deve ser posterior ou igual à data início.",
    function (fim) {
      const { inicioEm } = this.parent;
      if (!inicioEm || !fim) return true;
      return new Date(fim) >= new Date(inicioEm);
    }
  );

const optionalPositive = Yup.string().test(
  "optional-positive",
  "Deve ser um número maior ou igual a zero.",
  (v) => {
    if (v == null || v === "") return true;
    const n = Number(String(v).replace(/,/g, "."));
    return !Number.isNaN(n) && n >= 0;
  }
);

const optionalPositiveInteger = Yup.string().test(
  "optional-positive-integer",
  "Deve ser um número inteiro maior ou igual a zero.",
  (v) => {
    if (v == null || v === "") return true;
    const n = Number(String(v).replace(/,/g, "."));
    return !Number.isNaN(n) && n >= 0 && Number.isInteger(n);
  }
);

export const validationSchemaCreate = Yup.object().shape({
  codigo,
  tipo,
  valor,
  inicioEm: dataInicio,
  fimEm: dataFim,
  ativo: Yup.boolean().required(),
  subtotalMinimo: optionalPositive,
  limiteUsoGlobal: optionalPositiveInteger,
  limiteUsoPorUsuario: optionalPositiveInteger,
});

export const validationSchemaEdit = validationSchemaCreate;
